import ContextualMenuItem from './ContextualMenuItem';
import { ContextualMenuItemProps, ContextualMenuItemValueProps } from './types';

export type { ContextualMenuItemProps, ContextualMenuItemValueProps };
export default ContextualMenuItem;
